import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=7c63e840"
import script from "./FollowUp.ts?vue&type=script&lang=ts&external"
export * from "./FollowUp.ts?vue&type=script&lang=ts&external"
import style0 from "./FollowUp.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports